"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Dropdown = _interopRequireDefault(require("./Dropdown"));
var _data = _interopRequireDefault(require("./data"));
// 模拟数据

var Nav = function Nav(props) {
  var className = props.className,
    style = props.style,
    openDropdow = props.openDropdow,
    _props$openType = props.openType,
    openType = _props$openType === void 0 ? 'hover' : _props$openType,
    _props$emptyList = props.emptyList,
    emptyList = _props$emptyList === void 0 ? [] : _props$emptyList,
    _props$onClickMenu = props.onClickMenu,
    onClickMenu = _props$onClickMenu === void 0 ? function (arg) {} : _props$onClickMenu,
    _props$onDropDown = props.onDropDown,
    onDropDown = _props$onDropDown === void 0 ? function (arg) {} : _props$onDropDown,
    _props$onMouseEnter = props.onMouseEnter,
    _onMouseEnter = _props$onMouseEnter === void 0 ? function () {} : _props$onMouseEnter,
    _props$onMouseLeave = props.onMouseLeave,
    _onMouseLeave = _props$onMouseLeave === void 0 ? function () {} : _props$onMouseLeave,
    _props$onUserMouseEnt = props.onUserMouseEnter,
    onUserMouseEnter = _props$onUserMouseEnt === void 0 ? function () {} : _props$onUserMouseEnt,
    _props$onUserMouseLea = props.onUserMouseLeave,
    onUserMouseLeave = _props$onUserMouseLea === void 0 ? function () {} : _props$onUserMouseLea,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
    _props$menuData = props.menuData,
    menuData = _props$menuData === void 0 ? _data.default.nav : _props$menuData,
    _props$dropdownMenu = props.dropdownMenu,
    dropdownMenu = _props$dropdownMenu === void 0 ? _data.default.dropdownMenu : _props$dropdownMenu,
    curMenu = props.curMenu,
    curItem = props.curItem;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('nav');
  var classes = (0, _classnames.default)(prefixCls, className, {
    'is-open': openDropdow
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__bar")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__bar-inner")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__logos")
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "".concat(prefixCls, "__logo")
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__logo-icon")
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: "",
    className: "".concat(prefixCls, "__logo")
  }, "OCR\u4F53\u9A8C")), /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(prefixCls, "__list")
  }, menuData === null || menuData === void 0 ? void 0 : menuData.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: item.key,
      onMouseEnter: function onMouseEnter() {
        return _onMouseEnter(item);
      },
      onMouseLeave: function onMouseLeave() {
        return _onMouseLeave(item);
      },
      onClick: function onClick() {
        onClickMenu(item);
        // setOpenDropdow(!openDropdow);
      },
      className: (0, _classnames.default)("".concat(prefixCls, "__item"), {
        'has-sub': item.hasSub,
        'is-active': curMenu === item.key
      })
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
      }
    }, item.text));
  })))), openDropdow && dropdownMenu.length > 0 && /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    isActive: openDropdow && dropdownMenu.length > 0,
    emptyList: emptyList,
    close: onClose,
    onMouseEnter: function onMouseEnter() {
      return onUserMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      return onUserMouseLeave();
    },
    onDropDown: onDropDown,
    curItem: curItem,
    dropdownMenu: dropdownMenu
  }));
};
var _default = exports.default = Nav;